import React from 'react'
import Container from './container'

export default function DevopsAgility() {
  return (
    <section className="bg-[url(../assets/cover-proposito.png)] text-white">
      <Container className="py-12 md:py-20 flex flex-col items-center justify-center">
        <h2 className="text-4xl md:text-[40px] text-center mb-8 md:mb-16 px-8">
          Agilidade e Qualidade em{' '}
          <span className="bg-gradient-to-r from-[#4B3BDB] to-[#FC0021] bg-clip-text text-transparent relative">
            Toda Jornada
          </span>
        </h2>
        <div className="max-w-4xl mx-auto">
          <img
            src="/assets/devops.png"
            alt="DevOps Infinity Loop"
            className="h-auto w-[1000px]"
          />
        </div>
      </Container>
    </section>
  )
}
